import React from 'react'

export const Persona = () => {
  return (
    <div className='personas'>
        <div className='persona1'>
            <section >
                <img className='imagenpersonal' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685727011/guia_qwhgkk.jpg" alt="" />
            </section>
            <section className='info'>
                <h1 className='rol'>Guía</h1>
                <hr className='hrPersona'/>
                <h2 className='titulopersona'>Sebastián Alzate</h2>
                </section>
        </div>
        <div className='persona1'>
            <section>
                <img className='imagenpersonal' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685986057/santiago_Diaz_gkkapr.jpg" alt="" />
            </section>
            <section className='info'>
                <h1 className='rol'>Guía</h1>
                <hr className='hrPersona'/>
                <h2 className='titulopersona'>Santiago Diaz</h2>
                </section>
        </div>
        <div className='persona1'>
            <section>
                <img className='imagenpersonal' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685986061/escarra_y5u581.jpg" alt="" />
            </section>
            <section className='info'>
                <h1 className='rol'>Guía</h1>
                <hr className='hrPersona'/>
                <h2 className='titulopersona'>Stiven Escarraga</h2>
                </section>
        </div>
        <div className='persona1'>
            <section>
                <img className='imagenpersonal' src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685986050/bayron_iy2iy2.jpg" alt="" />
            </section>
            <section className='info'>
                <h1 className='rol'>Guía</h1>
                <hr className='hrPersona'/>
                <h2 className='titulopersona'>Bayron</h2>
                </section>
        </div>
    </div>
  )
}
